import { LayerGroup } from 'react-leaflet';
import AssetPositionMarker from '../markers/asset-position-marker/AssetPositionMarker';
import { isPositionModelWithLatLng, PositionModel } from '@cas/types/assets';
import { useTranslation } from 'react-i18next';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { AssetPositionTooltip } from '../tooltips/asset-position-tooltip/AssetPositionTooltip';
import { useAssetReportTime } from './useAssetReportTime';
import styles from './SingleAssetPositionLayer.module.scss';
import { getRotationProps, RotationModel } from '../markers/utils';

export interface SingleAssetPositionLayerProps {
  posG: PositionModel;
  customLabel?: string; // Used to show the PPUID.
  tooltipPane?: string; // Allow the tooltip pane to be overridden.
}

export function SingleAssetPositionLayer({
  posG,
  tooltipPane,
  customLabel,
}: SingleAssetPositionLayerProps) {
  const { t } = useTranslation();
  const { showRelative } = useLocaleFormatter();
  const title = t('LastGoodReport', { context: 'uppercase' });

  const rotationProps: RotationModel | undefined = isPositionModelWithLatLng(posG)
    ? getRotationProps(posG)
    : undefined;

  const { color, lastGoodReportTime } = useAssetReportTime(posG);

  return (
    <LayerGroup>
      {rotationProps && (
        <AssetPositionMarker {...rotationProps} color={color}>
          <AssetPositionTooltip pane={tooltipPane} title={title}>
            {customLabel && <span className={styles.text}>{customLabel}</span>}
            <span className={styles.text}>{showRelative(lastGoodReportTime)}</span>
          </AssetPositionTooltip>
        </AssetPositionMarker>
      )}
    </LayerGroup>
  );
}

export default SingleAssetPositionLayer;
